import axios from 'axios'

export default {
    items(locationId) {
        return axios.get(`${process.env.VUE_APP_API_URL}/catalog-items/` + locationId);
    },
    store(item) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/catalog-item`, item);
    },
    update(data) {
        return axios.put(`${process.env.VUE_APP_API_URL}/catalog-item/` + data.id , data);
    },
    delete(id) {
        return axios.delete(`${process.env.VUE_APP_API_URL}/catalog-item/` + id);
    },
    deleteCategory(id) {
        return axios.delete(`${process.env.VUE_APP_API_URL}/catalog-category/` + id);
    },
    updateItemsOrder(items) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/catalog-items/order`, {data: items});
    },
    storeCategory(category) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/catalog-category`, category);
    },
    updateCategory(data) {
        return axios.put(`${process.env.VUE_APP_API_URL}/catalog-category/` + data.id , data);
    },
    updateCategoryOrder(items) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/catalog-categories/order`, {data: items});
    }
}